import { IPizza } from 'misc/interfaces';
import pizzas from 'data/pizzas.json';

export const getAll: () => Promise<Array<IPizza>> = () =>
  Promise.resolve(pizzas as Array<IPizza>);
